var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Copyright © 2022 1 Click Design LLC reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }